export const defaultFilters = {
  statuses: [],
  stream_ids: [],
  group_name: null,
};
